import { StoryAudienceArticleGroomingStatusesQuery } from './__generated__/StoryAudienceArticleGroomingStatusesQuery';
import { useLazyQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { STORY_AUDIENCE_ARTICLE_GROOMING_STATUSES_QUERY } from './storyAudienceArticleGroomingStatuses.query';

interface Props {
  onCompleted?: (data: StoryAudienceArticleGroomingStatusesQuery) => void;
}

export const useStoryAudienceArticleGroomingStatusesQuery = ({ onCompleted }: Props) => {
  return useLazyQuery<StoryAudienceArticleGroomingStatusesQuery>(STORY_AUDIENCE_ARTICLE_GROOMING_STATUSES_QUERY, {
    onCompleted,
    client: kmsClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
};
